import { ForecastFreezingLevel } from './c-freezing-level.js';
import { ForecastWind } from './c-wind.js';
import { IForecast } from './types.js';

interface IForecastContent {
  forecast?: IForecast;
  classN?: string | undefined;
}

export function ForecastContent({ forecast: f }: IForecastContent) {
  if (f) {
    const { forecast, fzlStatement, wind } = f;
    return (
      <>
        <p data-module="forecast-content-mpf">{forecast}</p>
        <ForecastWind wind={wind} />
        <ForecastFreezingLevel fzlStatement={fzlStatement} />
      </>
    );
  }
  return null;
}
